import normalizeException from"normalize-exception";














export const handleUnsafeException=({
value,
changes,
path,
error,
size
})=>{

changes.push({
path,
oldValue:value,
newValue:undefined,
reason:"unsafeException",
error:normalizeException(error)
});
return{value:undefined,size}
};